var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-wrapper"},[_c('SideNav',{staticClass:"SideNav"}),_c('div',{staticClass:"main-wrapper"},[_c('Editor',{staticClass:"Editor",attrs:{"text":_vm.seedText}}),_c('MenuPanel',{staticClass:"MenuPanel"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }